module.exports = __webpack_public_path__ + "img/banner-structure.856a85da.jpg";